<template>
    <div class="relative" v-if="found && !loading && !completed">
        <div class="w-full px-8">
            <div v-show="step ===1">
                <p class="mb-8 text-xl font-hairline text-center">Tell us what you think about our <span class="font-normal">virtual professional</span> candidates.</p>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">Overall, how satisfied were you with the quality of the candidates vetted for you based on your needs?</p>
                    <button class="survey-answer sm:my-1" v-for="(name, key) in satisfiedOptions" :key="key" :class="form.qualityOfCandidates === name ? 'survey-answered' : ''" @click="form.qualityOfCandidates = name">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">I am confident about my Virtual Professional selection and overall hiring decision.</p>
                    <button class="my-1 survey-answer"  v-for="(name, key) in agreeOptions" :key="key" :class="form.confidenceInHiringDecision === name ? 'survey-answered' : ''" @click="form.confidenceInHiringDecision = name">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">Based on the quality of the Virtual Professionals I interviewed, I am optimistic that MyOutDesk is ____________.</p>
                    <button class="my-1 survey-answer" v-for="(name, key) in exceptionalOptions" :key="key"  :class="form.optimism == name ? 'survey-answered' : ''" @click="form.optimism = name">{{ name }}</button>
                </div>
            </div>
            <div v-show="step ===2">
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="mb-8 text-xl font-hairline text-center">Tell us what you think about our  <span class="font-normal">sales support and consultants</span>.</p>
                    <p class="survey-question">During initial contact, the person I spoke to was professional, knowledgeable, listened to my needs and addressed my inquiries and concerns.</p>
                    <button v-for="(name, key) in agreeOptions" :key="key" class="my-1 survey-answer" @click="form.sales.knowledgeability = name" :class="form.sales.knowledgeability == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">Overall, how satisfied were you with the quality of your Sales consultation and their subsequent follow through?</p>
                    <button v-for="(name, key) in satisfiedOptions" :key="key" class="my-1 survey-answer" @click="form.sales.satisfaction = name" :class="form.sales.satisfaction == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">How satisfied were you with our Sales Consultant’s ability to communicate our service offerings and our recommendations for your future business growth?</p>
                    <button v-for="(name, key) in satisfiedOptions" :key="key" class="my-1 survey-answer" :class="form.sales.abilities == name ? 'survey-answered' : ''" @click="form.sales.abilities = name" >{{ name }}</button>
                </div>
            </div>
            <div v-show="step ===3">
                <p class="mb-8 text-xl font-hairline text-center">Tell us what you think about our  <span class="font-normal">placements team</span>.</p>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">How satisfied were you with the quality and amount of communication between you and your Placement Specialist?</p>
                        <button v-for="(name, key) in satisfiedOptions" :key="key" class="my-1 survey-answer" @click="form.placements.knowledgeability = name" :class="form.placements.knowledgeability == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">Overall, I felt that my Placement Specialist listened to me and met my needs.</p>
                        <button v-for="(name, key) in agreeOptions" :key="key" class="my-1 survey-answer" @click="form.placements.abilities = name" :class="form.placements.abilities == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">How satisfied were you with the speed and efficiency at which your Placement Specialist was able to respond to your inquiries and requests?</p>
                        <button v-for="(name, key) in satisfiedOptions" :key="key" class="my-1 survey-answer" @click="form.placements.efficiency = name" :class="form.placements.efficiency == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
            </div>
            <div v-show="step ===4">
                <p class="mb-8 text-xl font-hairline text-center">Tell us what you think about our  <span class="font-normal">process and service</span>.</p>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question"> How was your overall experience with our Sales and sign-up process?</p>
                        <button v-for="(name, key) in excellentOptions" :key="key" class="my-1 survey-answer" @click="form.service.overallSignup = name" :class="form.service.overallSignup == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <p class="survey-question">How was your overall experience with our Virtual Professional interview and selection process?</p>
                        <button v-for="(name, key) in excellentOptions" :key="key" class="my-1 survey-answer" @click="form.service.overallSelectionProcess = name" :class="form.service.overallSelectionProcess == name ? 'survey-answered' : ''">{{ name }}</button>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <label>
                        <p class="survey-question">How have we delivered to you a consistently great Client Experience?</p>
                        <textarea rows="4" class="w-full md:w-5/6 lg:w-1/2 form-textarea" name="Deliverability" v-model="form.service.deliverability"/>
                    </label>
                </div>
                <div class="justify-center w-full mb-12 text-center md:flex-grow">
                    <label>
                        <p class="survey-question">How can we better serve you in the future?</p>
                        <textarea rows="4" class="w-full md:w-5/6 lg:w-1/2 form-textarea" name="Better Serve You" v-model="form.service.betterService"/>
                    </label>
                </div>

            </div>
        </div>
        <div class="w-full my-5 text-center">
            <button class="mr-2 text-black border btn" @click.stop.prevent="back" :disabled="step <= 1">Back</button>
            <button class="text-white border btn bg-brand border-brand" @click.stop.prevent="next" v-show="step < 4">Next</button>
            <button class="text-white border btn bg-brand border-brand" @click.stop.prevent="submit" v-show="step === 4">Submit Survey</button>
        </div>
    </div>
    <div v-else-if="!found && !loading && !completed" class="relative my-8 text-center">
        <span class="text-xl tracking-wider">Survey Not Found</span>
    </div>
    <pulse-loader  v-else-if="loading" color="#4a5568" :loading="loading" class="relative my-8 text-center"/>
    <div v-else-if="completed" class="relative my-8 text-center">
        Survey Completed. Thank you!
    </div>
</template>

<script>

    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    export default {
        name: 'Survey',
        components: {
            PulseLoader
        },
        data() {
            return {
                loading: false,
                found: false,
                completed: false,
                step: 1,
                urlParams: {},
                salesRepresentative: null,
                placementSpecialist: null,
                excellentOptions: [
                    'Poor',
                    'Fair',
                    'Good',
                    'Very Good',
                    'Excellent',
                ],
                satisfiedOptions: [
                    'Dissatisfied',
                    'Very Dissatisfied',
                    'Neutral',
                    'Satisfied',
                    'Very satisfied',
                ],
                agreeOptions: [
                    'Disagree',
                    'Strongly disagree',
                    'Neutral',
                    'Agree',
                    'Strongly agree',
                ],
                exceptionalOptions: [
                    'I don\'t think I am getting good value for my investment',
                    'A good value for my investment',
                    'An exceptional value for my investment',
                ],
                form: {
                    qualityOfCandidates: null,
                    confidenceInHiringDecision: null,
                    optimism: null,
                    sales: {
                        satisfaction: null,
                        knowledgeability: null,
                        abilities: null,
                    },
                    placements: {
                        knowledgeability: null,
                        abilities: null,
                        efficiency: null,
                    },
                    service: {
                        overallSignup: null,
                        overallSelectionProcess: null,
                        deliverability: null,
                        betterService: null
                    },
                }
            };
        },
        methods: {
            async getEndorsementForm() {
                if(!this.urlParams.id || !this.urlParams.client_secret){
                    return;
                }
                this.loading = true;
                try {
                    let response = await this.$http.get(`endorsement?id=${this.urlParams.id}&signature=${this.urlParams.client_secret}`);
                    this.salesRepresentative = response.data.sales_consultant;
                    this.placementSpecialist = response.data.placement_specialist;
                    this.found = true;
                }
                catch(error){
                    this.found = false;
                    console.error(error)
                }
                this.loading = false;
            },
            async submit(){
                this.loading = true;
                try{
                    await this.$http.post('/submit', this.form)
                    this.completed = true;
                }
                catch(error){
                    console.log(error.response)
                }
                this.loading = false;
            },
            getUrlParams() {
                let match,
                    pl = /\+/g,  // Regex for replacing addition symbol with a space
                    search = /([^&=]+)=?([^&]*)/g,
                    decode = function(s) {
                        return decodeURIComponent(s.replace(pl, ' '));
                    },
                    query = window.location.search.substring(1);

                while ((match = search.exec(query)) !== null)
                    this.urlParams[decode(match[1])] = decode(match[2]);
            },
            back(){
                this.step--;
                window.scrollTo(0,0)
            },
            next(){
              this.step++;
              window.scrollTo(0,0);
            }
        },
        mounted() {
            this.getUrlParams();
            this.getEndorsementForm();
            this.form.id = this.urlParams['id']
        },
    };
</script>

<style scoped>

</style>
